function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowLeft2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707107,0.707107,-0.707107,0.707107,8.27217,-3.81371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,3C6,2.448 5.552,2 5,2C4.448,2 4,2.448 4,3L4,11C4,11.552 4.448,12 5,12C5.552,12 6,11.552 6,11L6,3Z",
    style: {
      fill: "rgb(196,196,196)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,11C14,10.448 13.552,10 13,10L5,10C4.448,10 4,10.448 4,11C4,11.552 4.448,12 5,12L13,12C13.552,12 14,11.552 14,11Z",
    style: {
      fill: "rgb(196,196,196)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft2);
export default __webpack_public_path__ + "static/media/icon--arrow--left2.182cc8257ab1cc21fdb7b8f7340bc834.svg";
export { ForwardRef as ReactComponent };